import { Divider, MenuItem, TextField, TextFieldProps } from "@material-ui/core";

export interface ILyfeTextField {
	options?: Array<{ label: string; value: string | number }>;
	mandatory?: boolean;
	techOptionsNo?: number;
}

export default function LyfeTextField(props: ILyfeTextField & TextFieldProps) {
	const { options, ...other } = props;
	const requiredStyle = {
		borderLeft: "5px solid #367bf5",
		borderRadius: "5px 0px 0px 5px",
	};

	return (
		<TextField
			inputProps={other.required && other.mandatory ? { style: requiredStyle } : undefined}
			SelectProps={other.select && other.required && other.mandatory ? { SelectDisplayProps: { style: requiredStyle } } : undefined}
			{...other}
		>
			{options &&
				options.map((option, i) => [
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>,
					props.techOptionsNo && i === props.techOptionsNo - 1 && (
						<div style={{ padding: "0 20px" }}>
							<Divider />
						</div>
					),
				])}
		</TextField>
	);
}
